import React from "react";
import { getCmsData } from "../../functions";

class PrimaryNavigation extends React.Component {
  constructor(props) {
    super(props);

    const cmsData = getCmsData("megaMenu");
    if (!cmsData) return null;

    const { categories } = cmsData;
    this.loadedCategories = categories;

    this.timerid = null;
    this.state = {
      // categories: props.categories,
      categories: this.loadedCategories,
      menuState: "inactive",
    };

    //Close menu when click outside
    document.querySelector("body").addEventListener("touchstart", (e) => {
      console.log(e.target);
      if (!this.node.contains(e.target)) {
        this.closeMenu();
      }
    });
  }

  removeAllCurrentTabs() {
    var listItems = document.querySelectorAll(".primary-navigation-list li");
    for (var i = 0; i < listItems.length; i++) {
      if (listItems[i].classList == "current-tab") {
        listItems[i].classList.remove("current-tab");
      }
    }
  }

  currentTab = (e) => {
    document.querySelector("body").addEventListener("mouseover", (e) => {
      // Check if e.target and its parent elements exist
      if (
        e.target &&
        e.target.parentNode &&
        e.target.parentNode.parentNode &&
        e.target.parentNode.parentNode.parentNode &&
        e.target.parentNode.parentNode.parentNode.className ===
          "primary-navigation-list"
      ) {
        this.removeAllCurrentTabs();
        e.target.parentNode.parentNode.classList.add("current-tab");
      }
    });

    if (this.state.menuState === "inactive") {
      this.removeAllCurrentTabs();
    }
  };

  openMenu = (category, props, e) => {
    if (
      this.state.menuState == "inactive" &&
      ("ontouchstart" in window ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0)
    ) {
      //e.preventDefault();
    }
    this.currentTab(e);

    if (e.key == "Tab" || e.type == "mouseenter") {
      clearTimeout(this.timerid);
      this.timerid = setTimeout(() => {
        this.setState({
          menuState: "active",
          id: category,
          categories: this.loadedCategories.filter((c) => {
            return category == c.id;
          }),
        });
      }, 200);
    }
  };

  closeMenu = (e) => {
    //Cancel delayed menu load if mouse leaves Li element.
    if (this.timerid) {
      clearTimeout(this.timerid);
    }

    this.setState(
      {
        menuState: "inactive",
      },
      () => {
        this.currentTab(e);
      }
    );
  };

  keyboardMenuFocus = (e) => {
    //Shift focus to megaMenu
    var primaryNavTabs = document.querySelectorAll(
      ".primary-navigation-list li"
    );
    var lastTabItem =
      primaryNavTabs[primaryNavTabs.length - 1].querySelectorAll("a")[0];
    var toggleState = 0;
    if (lastTabItem == e.target) {
      toggleState = 1;
    }
    if (e.key == "ArrowDown") {
      let menuCategory = e.target;
      let menuItems = document.querySelectorAll(".mega-menu-link-list a");
      menuItems[0].focus();
      let lastItem = document.querySelectorAll(".mega-menu-link-list a")[
        menuItems.length - 1
      ];
      lastItem.addEventListener("keydown", (e) => {
        if (e.key == "Tab" && toggleState != 1) {
          setTimeout(function () {
            menuCategory.focus();
          }, 200);
          toggleState = 0;
        } else {
          this.setState({
            menuState: "inactive",
          });
        }
      });
    }

    if (e.key == "Tab" && lastTabItem == e.target) {
      this.setState({
        menuState: "inactive",
      });
    }
  };

  render() {
    return (
      <nav id="primary-navigation" ref={(node) => (this.node = node)}>
        <div className="container-fluid">
          <ul
            className="primary-navigation-list"
            onMouseLeave={(e) => this.closeMenu()}
          >
            {this.loadedCategories.map((categories, index) => {
              return (
                <li
                  key={categories.id}
                  onMouseEnter={(e) => this.openMenu(categories.id, null, e)}
                  onKeyUp={(e) => this.openMenu(categories.id, null, e)}
                  onKeyDown={(e) => this.keyboardMenuFocus(e)}
                  className={
                    window.location.href.includes(categories.pageURL) &&
                    "current-page"
                  }
                >
                  <span>
                    <a href={categories.pageURL}>{categories.id}</a>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
        <div
          id="mega-menu"
          onKeyDown={(e) => this.keyboardMenuFocus(e)}
          onMouseEnter={(e) => this.setState({ menuState: "active" })}
          onMouseLeave={(e) => this.closeMenu()}
          className={this.state.menuState}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <ul className="mega-menu-link-list">
                  {this.state.categories[0].pages.map((pages, index) => (
                    <li key={pages.pageName}>
                      <a href={pages.pageURL}>{pages.pageName}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default PrimaryNavigation;
